var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#73AF00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_24479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66699 21.4163C7.66699 21.9026 7.86015 22.3689 8.20396 22.7127C8.54778 23.0565 9.0141 23.2497 9.50033 23.2497C9.98656 23.2497 10.4529 23.0565 10.7967 22.7127C11.1405 22.3689 11.3337 21.9026 11.3337 21.4163C11.3337 20.9301 11.1405 20.4638 10.7967 20.12C10.4529 19.7762 9.98656 19.583 9.50033 19.583C9.0141 19.583 8.54778 19.7762 8.20396 20.12C7.86015 20.4638 7.66699 20.9301 7.66699 21.4163Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5833 19.583C19.2207 19.583 18.8663 19.6905 18.5648 19.892C18.2633 20.0934 18.0283 20.3798 17.8896 20.7148C17.7508 21.0498 17.7145 21.4184 17.7852 21.774C17.856 22.1296 18.0306 22.4563 18.287 22.7127C18.5434 22.9691 18.87 23.1437 19.2257 23.2144C19.5813 23.2852 19.9499 23.2489 20.2849 23.1101C20.6199 22.9714 20.9062 22.7364 21.1077 22.4349C21.3091 22.1334 21.4167 21.7789 21.4167 21.4163",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5833 19.5833H9.5V9.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4691 8.7959L22.3333 9.50082L21.4167 15.9175H19.5833M15.9167 15.9175H9.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.75L23.25 23.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_24479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryStock);
export default __webpack_public_path__ + "static/media/InventoryStock.147eebb38f75ebd4499aa6d8c661b2bd.svg";
export { ForwardRef as ReactComponent };